import { Drawer } from 'antd';
import cn from 'classnames';

import { useLeadCardContext } from '@app/components/LeadCard/context';
import { AddBranchModal } from '@app/components/LeadCard/ui/AddBranchModal';
import { LeadListPanel } from '@app/components/LeadCard/ui/LeadListPanel';
import { MainPanel } from '@app/components/LeadCard/ui/MainPanel';
import { UserDetailsPanel } from '@app/components/LeadCard/ui/UserDetailsPanel';

import './Layout.scss';

export const Layout = () => {
  const {
    cardRef,
    isLeadListEnabled,
    isLeadListDrawerOpen,
    isUserDetailsDrawerOpen,
    closeLeadListDrawer,
    closeUserDetailsDrawer,
    showLeadsColumn,
    showDetailsColumn,
  } = useLeadCardContext();

  return (
    <section
      ref={cardRef}
      // Модификаторы повторяют решение по ширине карточки (а не окна):
      // медиазапросы в Layout.scss остаются как поведение по умолчанию, а
      // эти классы выключают колонки, когда карточка узкая — например,
      // внутри модалки записи (issue/10978).
      className={cn('LeadCard', {
        'LeadCard--without-lead-list': !isLeadListEnabled,
        'LeadCard--lead-list-hidden': isLeadListEnabled && !showLeadsColumn,
        'LeadCard--details-hidden': !showDetailsColumn,
      })}
    >
      <div className="LeadCard__grid">
        {isLeadListEnabled && showLeadsColumn && (
          <aside className="LeadCard__lead-list-column">
            <LeadListPanel />
          </aside>
        )}

        <MainPanel />

        <aside className="LeadCard__user-details-column">
          <UserDetailsPanel />
        </aside>
      </div>

      {isLeadListEnabled && !showLeadsColumn && (
        <Drawer
          className="LeadCard__drawer"
          rootClassName="LeadCard__drawer-root"
          classNames={{
            header: 'LeadCard__drawer-header',
          }}
          title="Лиды"
          open={isLeadListDrawerOpen}
          onClose={closeLeadListDrawer}
          placement="left"
          width={280}
          getContainer={false}
        >
          <LeadListPanel closeDrawer={closeLeadListDrawer} />
        </Drawer>
      )}

      {!showDetailsColumn && (
        <Drawer
          className="LeadCard__drawer"
          rootClassName="LeadCard__drawer-root"
          classNames={{
            header: 'LeadCard__drawer-header',
          }}
          title="Детали лида"
          open={isUserDetailsDrawerOpen}
          onClose={closeUserDetailsDrawer}
          placement="right"
          width={360}
          getContainer={false}
        >
          <UserDetailsPanel />
        </Drawer>
      )}

      <AddBranchModal />
    </section>
  );
};
